<template>
    <div>
        <rkm-modal
            :buttons="['cancel']"
            large
            ref="RkmModal"
            title="Exames solicitados"
        >

            <rkm-alert show info v-if="item">
                <strong>Paciente:</strong>

                {{ item.pacienteNome }}

                <strong v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                    ({{ item.PacienteNomeSocial }})
                </strong> -

                <strong>Idade:</strong>
                        <template v-if="item.pacienteIdade">
                            {{ item.pacienteIdade }}
                        </template>
                        <template v-else>
                            -
                        </template> -
                    <strong>Prontuário: </strong>{{ item.pacienteProntuario }} -
                    <strong>Agendamento: </strong>{{ item.agendamentoNumero }}
            </rkm-alert>

            <template>
                <rkm-table
                    :items="items"
                    :fields="fields"
                />
            </template>
        </rkm-modal>
    </div>
</template>

<script>

// Mixins.
import { error } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "exame",
                    label: "Exame",
                    class: 'col-12',
                    sortable: true
                }
            ]

            return fields
        },
    },
    data: () => ({
        dia: null,
        semanaId: null,
        items: [],
        item: null,
        enums: {
            preferenciaNome,
        },
    }),
    methods: {
        open(item) {

            this.item = item
            this.items = []

            if (item.exames) {

                item.exames.split(',').forEach(exame => {

                    this.items.push({ exame: exame})
                })
            }

            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error ],
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
</style>
